import { Component } from '@angular/core';

@Component({
    templateUrl: 'learn-about-tidy.html',
    standalone: false
})
export class LearnAboutTidyPage {}
